module.exports = __webpack_public_path__ + "img/swal-info.1aedf032.svg";